export default "__VITE_ASSET__CEexQEps__"